import {
	Component,
	forwardRef,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { Division } from 'src/shared/api';
import {
	displayName,
	idComparer,
} from 'src/shared/utilities/utility-functions';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import {
	ControlValueAccessor,
	FormControl,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
	takeUntil,
	map,
	filter,
	distinctUntilChanged,
	skipWhile,
} from 'rxjs/operators';

@Component({
	selector: 'rpshared-division-link',
	templateUrl: './division-link.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DivisionLinkComponent),
			multi: true,
		},
	],
})
export class DivisionLinkComponent extends SelfDestruct
	implements ControlValueAccessor {
	@Input() divisions: Division[] = [];
	@Output() optionSelected = new EventEmitter<Division>();

	initialValue: Division;
	division = new FormControl('') as FormControl;

	readonly idComparer = idComparer;
	readonly displayName = displayName;

	constructor() {
		super();
	}

	// model --> view
	writeValue(value: Division): void {
		if (value) {
			this.initialValue = value;
			this.division.setValue(value, { emitEvent: false });
		}
	}

	// view --> model
	registerOnChange(fn: (value: Division | number) => void) {
		this.division.valueChanges
			.pipe(
				filter((v) => !v || typeof v !== 'string'),
				distinctUntilChanged(),
				takeUntil(this.destroyed)
			)
			.subscribe(fn);
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	onTouched: () => void = () => {};
}

@Component({
	selector: 'rpshared-division-id',
	templateUrl: './division-link.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DivisionIdComponent),
			multi: true,
		},
	],
})
export class DivisionIdComponent extends DivisionLinkComponent {
	registerOnChange(fn: (value: Division | number) => void) {
		this.division.valueChanges
			.pipe(
				filter((v) => !v || typeof v !== 'string'),
				map((v) => (v ? v.id : null)),
				distinctUntilChanged(),
				skipWhile<number | null>((v) => !v && !this.initialValue),
				takeUntil(this.destroyed)
			)
			.subscribe(fn);
	}
}
